import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const tenantList = [
  'exchange',
  // TODO: Re-enable non-exchange tenants when ready
  // 'paribu-self',
  // 'custody',
  // 'paribu-stock',
  // 'money',
  // 'pass',
]

const pageMap: Record<string, Record<string, string>> = {
  // Dictionary modülü pasif - tekrar aktif etmek için yorum satırından çıkarın
  // dictionary: {
  //   tr: 'sozluk',
  //   en: 'dictionary',
  // },
  announcement: {
    tr: 'duyurular',
    en: 'announcement',
  },
  status: {
    tr: 'status',
    en: 'status',
  },
  search: {
    tr: 'arama',
    en: 'search',
  },
  'settings/language-preferences': {
    tr: 'ayarlar/dil-secenekleri',
    en: 'settings/language-preferences',
  },
}

// Dictionary modülü pasif - tekrar aktif etmek için 'dictionary' ekleyin
const tenantExcludedPages = ['announcement', 'status', 'search']
const tenantExcludedPrefixes = ['settings']

export function useAppLink(): { appLink: (path: string | string[]) => string } {
  const route = useRoute()
  const { locale } = useI18n()

  const language = locale.value.split('-')[0] || 'tr'

  function translateSegment(segment: string): string {
    return pageMap[segment]?.[language] ?? pageMap[segment]?.['en'] ?? segment
  }

  function appLink(path: string | string[]): string {
    let currentTenant = route.params.tenant?.toString() || 'exchange'
    if (!tenantList.includes(currentTenant)) currentTenant = 'exchange'

    const segments = Array.isArray(path)
      ? path
      : path.replace(/^\/+/, '').split('/').filter(Boolean)

    const translatedSegments = segments.map(translateSegment)

    const firstSegment = segments[0]
    const isTenantExcluded =
      tenantExcludedPages.includes(firstSegment) ||
      tenantExcludedPrefixes.some((prefix) => firstSegment.startsWith(prefix))

    const tenantPrefix = isTenantExcluded || currentTenant === 'exchange' ? '' : `/${currentTenant}`

    return `${tenantPrefix}/${translatedSegments.join('/')}`
  }

  return { appLink }
}
